import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Button, Spinner } from "react-bootstrap";
import ModalCrud from "./UserModal";
import { DoLogout } from "../Utils";

export default function BulkProcessUsers(props) {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const displayFormat = "DD/MM/YYYY";
  var moment = require("moment");

  const [isLoading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [userDetail, setUserDetail] = useState(null);

  const token = JSON.parse(ls.get("jwt"));

  useEffect(() => {
    GetUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const validateEmail = (email) => {
    return (
      email &&
      email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    );
  };

  function GetError(error) {
    return error.response
      ? "ERROR: " + error.response.data?.error?.message
      : "ERROR: " + error.mesage;
  }

  const GetUsers = async () => {
    setLoading(true);

    const res = await axios
      .get(
        `${API_URL}/temp-users?populate=*&sort[0]=lastname%3Aasc&filters[state][$eq]=NEW&pagination[pageSize]=1000`,
        headerRequest
      )
      .catch((error) => {
        console.log("Error with temp-users:", error);
        if (error.response.status === 401) DoLogout();
      });
    const users = res.data.data;

    Promise.all(
      users.map(async (user) => {
        user.attributes.lastname = user.attributes.lastname.toUpperCase();
        user.attributes.name = user.attributes.name.toUpperCase();
        user.attributes.email = user.attributes.email.toLowerCase();

        if (moment(user.attributes.birthDate, true).isValid() !== true) {
          user.attributes.birthDate = `Inválida. (${user.attributes.birthDate})`;
        } else if (
          moment().diff(moment(user.attributes.birthDate, true), "minutes") < 0
        ) {
          user.attributes.birthDate = `Muy joven. (${user.attributes.birthDate})`;
        }

        if (moment(user.attributes.startDate, true).isValid() !== true) {
          user.attributes.startDate = `Inválida. (${user.attributes.startDate})`;
        } else if (
          moment(user.attributes.startDate, true).diff(
            moment(user.attributes.birthDate, true),
            "minutes"
          ) < 0
        ) {
          user.attributes.startDate = `Menor F.Nac. (${user.attributes.startDate})`;
        }

        if (!validateEmail(user.attributes.email)) {
          user.attributes.email = `Inválido (${user.attributes.email})`;
        } else {
          // Validar email duplicado
          await axios
            .get(
              `${API_URL}/users/?filters[email][$eq]=${user.attributes.email}`,
              headerRequest
            )
            .then((users) => {
              if (users.data.length > 0) {
                for (let i = 0; i < users.data.length; i++) {
                  if (users.data[i].docNumber !== user.attributes.docNumber) {
                    user.attributes.email = `Duplicado (${user.attributes.email})`;
                    break;
                  }
                }
              }
            })
            .catch((error) => {
              user.attributes.email = `ERROR (${user.attributes.email})`;
            });
        }

        user.createdByUserName = `No existe`;
        if (user.attributes.createdByUser) {
          const resCreated = await axios.get(
            `${API_URL}/users/${user.attributes.createdByUser}`,
            headerRequest
          );
          const userCreated = resCreated.data;
          if (userCreated) {
            user.createdByUserName =
              userCreated.name + " " + userCreated.lastname;
          }
        }

        user.result = "A procesar";
        return user;
      })
    ).then((users) => {
      setUsers(users);
      setLoading(false);
    });
  };

  const EditUser = (data) => {
    setUserDetail(data);
    setShowModal(true);
  };

  const processData = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Procesar todos los items pendientes
    for (let i = 0; i < users.length; i++) {
      const item = users[i];

      // Validar en base a lo cargado
      if (!validateEmail(item.attributes.email)) {
        users[i].result = "ERROR: Email Inválido";
        continue;
      }
      if (moment(item.attributes.birthDate, true).isValid() !== true) {
        users[i].result = "ERROR: Fecha Nac. inválida";
        continue;
      }
      if (moment(item.attributes.startDate, true).isValid() !== true) {
        users[i].result = "ERROR: Fecha Ingreso inválida";
        continue;
      }

      let isError = false;

      let reqUser = {
        docNumber: null,
        lastname: null,
        name: null,
        email: null,
        birthDate: null,
        startDate: null,
        username: null,
        password: "invalidated",
        provider: "local",
        confirmed: true,
        role: 1,
      };
      await axios
        .get(
          `${API_URL}/users/?filters[docNumber][$eq]=${item.attributes.docNumber}`,
          headerRequest
        )
        .then((user) => {
          if (user.data.length > 0) reqUser = user.data[0];
        })
        .catch((error) => {
          isError = true;
          users[i].result = GetError(error);
        });
      if (isError) continue;

      reqUser.username = item.attributes.docNumber;
      reqUser.docNumber = item.attributes.docNumber;
      reqUser.lastname = item.attributes.lastname.toUpperCase();
      reqUser.name = item.attributes.name.toUpperCase();
      reqUser.email = item.attributes.email.toLowerCase();
      reqUser.birthDate = item.attributes.birthDate;
      reqUser.startDate = item.attributes.startDate;

      let processToBeMade = "";
      if (reqUser.id >= 0) {
        processToBeMade = "UPDATED";
        await axios
          .put(`${API_URL}/users/${reqUser.id}`, reqUser, headerRequest)
          .catch((error) => {
            isError = true;
            console.log("Error with put users:", error.response);
            users[i].result = GetError(error);
          });
      } else {
        processToBeMade = "CREATED";
        await axios
          .post(`${API_URL}/users`, reqUser, headerRequest)
          .catch((error) => {
            isError = true;
            console.log("Error with post users:", error.response);
            users[i].result = GetError(error);
          });
      }
      if (isError) continue;

      // Una vez creado/actualizado el usuario, marcar el temp como procesado
      const reqTempUser = {
        data: {
          state: processToBeMade,
        },
      };
      await axios
        .put(`${API_URL}/temp-users/${item.id}`, reqTempUser, headerRequest)
        .catch((error) => {
          isError = true;
          console.log("Error with post temp-users:", error.response);
          users[i].result = GetError(error);
        });
      if (isError) continue;

      users[i].result = "OK";
    }

    setUsers(users.filter((e) => e.result !== "OK"));
    setLoading(false);
  };

  const renderData = (
    <>
      <Table
        striped
        hover
        size="sm"
        responsive="sm"
        style={{ fontSize: ".8em" }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>DNI</th>
            <th>Apellido</th>
            <th>Nombres</th>
            <th>Email</th>
            <th>Fecha Nac.</th>
            <th>Fecha Ingreso</th>
            <th>Alta</th>
            <th>Resultado</th>
            <th>
              <Button
                size="sm"
                variant="success"
                className="btn-xs"
                onClick={() => EditUser(null)}
              >
                CREAR
              </Button>
            </th>
          </tr>
        </thead>
        <tbody>
          {users.length < 1 ? (
            <tr>
              <td colSpan="10" align="center">
                No hay exámenes pendientes de procesar.
              </td>
            </tr>
          ) : (
            users.map((u) => (
              <tr key={u.id}>
                <td align="center">{u.id}</td>
                <td align="center">{u.attributes.docNumber}</td>
                <td align="left">{u.attributes.lastname}</td>
                <td align="left">{u.attributes.name}</td>
                <td align="left">{u.attributes.email}</td>
                <td align="center">
                  {moment(u.attributes.birthDate).format(displayFormat)}
                </td>
                <td align="center">
                  {moment(u.attributes.startDate).format(displayFormat)}
                </td>
                <td align="left">{u.createdByUserName}</td>
                <td align="left">{u.result}</td>
                <td align="center">
                  <Button
                    size="sm"
                    className="btn-xs"
                    onClick={() => EditUser(u)}
                    variant="warning"
                  >
                    Editar
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <Button
        size="sm"
        variant="success"
        onClick={(e) => {
          processData(e);
        }}
      >
        PROCESAR
      </Button>
      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          className="modal-background"
        ></div>
      )}
      {showModal && (
        <ModalCrud
          show={showModal}
          user={userDetail}
          onHide={(saved) => {
            setShowModal(false);
            if (saved === true) GetUsers();
          }}
        />
      )}
    </>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      <h4>PROCESAR ALUMNOS</h4>
      <p>Revise la lista de pendientes y presione Procesar</p>
      {isLoading ? <Spinner animation="border" /> : renderData}
    </Container>
  );
}
